import React, { useState } from 'react';
import JobTile from '../JobTile/JobTile';
import { Layout } from '../Layout/Layout';
import Loader from '../Loader/Loader';

export default function JobBid(){
    // const [isLoading, setIsLoading] = useState(false);
    return(
        <>
        {/* { isLoading === true ? <Loader  /> : '' } */}
        <Layout>
            <JobTile title="Bid Jobs" type="4" />           
        </Layout>
        </>
    )
}
